import { IdleQueue } from 'idlefy/min';
const queue = new IdleQueue({ ensureTasksRun: true });

export const pushToNonCriticalQueue = callback => {
  try {
    queue.pushTask(() => callback());
  } catch (er) {
    console.error('Exception in pushToNonCriticalQueue', er);
  }
};
